<template>
    <v-container class="pa-0">
        <v-row no-gutters align="end" :style="{ backgroundColor: backgroundcolor }" class="pa-3 pb-0">
            <v-col cols="0" :key="descriptionKey">
                <QTextField v-model="inputValue" :label="$t('servicesystem.common_objects.order.description')"
                    externaledit :disabled="loading || readonly" :backgroundcolor="backgroundcolor">
                </QTextField>
            </v-col>
            <v-col v-if="!readonly" cols="auto">
                <v-btn icon small class="ml-2" color="primary" :disabled="descriptionLoading || readonly || loading || descriptionMatches"
                    @click="resetDescription()">
                    <v-icon size="20">mdi-restore</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import ClientAPI from "@/api/ClientAPIMixin";
import { debounce } from "debounce";

export default {
    name: "AutoArticleDescription",
    props: {
        detail: Object,
        loading: Boolean,
        readonly: Boolean,
        backgroundcolor: {
            type: String,
            default: '#f9f9f9'
        }
    },
    components: {},

    data() {
        return {
            descriptionPlaceholder: "",
            descriptionKey: 1,
            wasMatched: false,
            descriptionLoading: false,
        };
    },

    mounted() {
        //if undefined set after placeholder fetch
        this.wasMatched = this.detail.ArticleDescription === undefined;

        this.getDescriptionPlaceholder()
            .then(() => {
                this.wasMatched = this.descriptionMatches ? true : false;
            });

    },

    methods: {
        debounceGetDescriptionPlaceholder: debounce(async function () {
            this.descriptionLoading = true;
            this.getDescriptionPlaceholder();
        }, 700),

        async getDescriptionPlaceholder() {
            this.descriptionLoading = true;
            const dto = Object.assign({}, this.detail);
            var result = await ClientAPI.methods.composeArticleDescription(dto)
            this.descriptionPlaceholder = result || "";
            if (this.wasMatched) {
                this.resetDescription();
            }
            this.descriptionLoading = false;
        },

        resetDescription() {
            this.inputValue = this.descriptionPlaceholder;
            this.descriptionKey++;
            this.wasMatched = true;
            console.log("Reset description to:", this.descriptionPlaceholder);
        },
    },

    computed: {
        inputValue: {
            get() {
                return this.detail.ArticleDescription;
            },
            set(value) {
                this.wasMatched = (this.descriptionPlaceholder == value);
                this.$emit('change', value ?? '');
            }
        },

        jsonObject() {
            var reducedObject = {
                ArticleNumber: this.detail.ArticleNumber,
                EmploymentTimeReportDate: this.detail.EmploymentTimeReportDate,
                EmploymentId: this.detail.EmploymentId,
                StartDateTime: this.detail.StartDateTime,
                StopDateTime: this.detail.StopDateTime,
                Type: this.detail.Type,
            };
            return JSON.stringify(reducedObject);
        },

        descriptionMatches() {
            return this.inputValue == this.descriptionPlaceholder;
        },
    },

    watch: {
        jsonObject: function () {
            this.debounceGetDescriptionPlaceholder();
        },
    }
}
</script>


<style scoped></style>
